export default "__VITE_ASSET__21bccb50__"